/* Buy now uses Shopify's native product POST and checkout redirect. Dawn still
   owns ordinary Add to cart submissions. No duplicate product forms for apps. */
document.addEventListener('submit', (event) => {
  if (!event.submitter?.matches('[data-bc-card-buy]')) return;
  if (!event.target.matches('.bc-card-actions form')) return;
  // Allow the browser's native submit, including the clicked return_to button,
  // without Dawn converting this particular submission into a drawer update.
  event.stopImmediatePropagation();
}, true);

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-bc-catalog-sort]')) event.target.form.requestSubmit();
});
